import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchApplications = createAsyncThunk(
  'applications/fetchApplications',
  async ({ q = '', filter = '', limit = 100 }, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=applications-list', { params: { q, filter, limit } });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const updateApplicationStatus = createAsyncThunk(
  'applications/updateStatus',
  async ({ applicationId, status }, { rejectWithValue }) => {
    try {
      const response = await api.post('/?action=applications-update-status', { application_id: applicationId, status });
      return { applicationId, status: response.data.data.status };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

const applicationsSlice = createSlice({
  name: 'applications',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchApplications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateApplicationStatus.fulfilled, (state, action) => {
        const app = state.items.find(a => a.id === action.payload.applicationId);
        if (app) app.status = action.payload.status;
      });
  },
});

export const { clearError } = applicationsSlice.actions;
export default applicationsSlice.reducer;
